/**
 * Единый формат ошибок для UI.
 * code — машинный код: коды контракта (INVITE_INVALID, EMAIL_TAKEN…), UNAUTHORIZED, FORBIDDEN,
 * коды Better Auth (INVALID_EMAIL_OR_PASSWORD…), RATE_LIMITED, NETWORK, UNKNOWN.
 */
export class DataError extends Error {
    code;
    status;
    issues;
    constructor(code, status, message, 
    /** Для VALIDATION_FAILED — проблемы по полям (путь — код поля). */
    issues = []) {
        super(message ?? code);
        this.code = code;
        this.status = status;
        this.issues = issues;
        this.name = 'DataError';
    }
}
//# sourceMappingURL=data-client.js.map